import * as defaultValues from "./logisticsFormDefaultValues"
import * as validation from "./logisticsFormValidation"
import * as submit from "./logisticsFormParams"

export const logisticsFormHelper = {
  defaultValues,
  validation,
  submit,
}
